export const contractorsRoutes = {
  internal: {
    getImpersonateToken: '/internal/contractors/:id/impersonate',
    createContractor: '/internal/contractors',
    getContractor: '/internal/contractors/:id',
    getContractors: '/internal/contractors',
    getContractorsList: '/internal/contractors/list',
    updateContractor: '/internal/contractors/:id',
    getActivePromos: '/internal/contractors/:id/promos/active',
    getAvailablePromos: '/internal/contractors/:id/promos/available',
    updateContractorPromos: '/internal/contractors/:id/promos',
  },
};
